<template>
  <div style="height: 100%; overflow: auto;" :style="{overflow: view.includes('graph') ? 'hidden' : 'auto'}">
    <div v-if="isLoaded">
      <v-simple-table v-if="view === 'table1'">
        <template #default>
          <tbody>
            <tr style="background-color: #4CAF5020;">
              <th>Принятые</th>
              <td>{{ table.items.accepted_calls_count }}</td>
            </tr>
            <tr style="background-color: #FF980020;">
              <th>Пропущенные с ожиданием менее порогового значения</th>
              <td>{{ table.items.missed_calls_count_less_wait_time }}</td>
            </tr>
            <tr style="background-color: #F4433620;">
              <th>Пропущенные с ожиданием более порогового значения</th>
              <td>{{ table.items.missed_calls_count_more_wait_time }}</td>
            </tr>
            <tr>
              <th>Выход из очереди по нажатию</th>
              <td>{{ table.items.missed_calls_count_exitwithkey }}</td>
            </tr>
            <tr>
              <th>Выход из очереди по таймауту</th>
              <td>{{ table.items.missed_calls_count_exitwithtimeout }}</td>
            </tr>
            <tr>
              <th>Фактический уровень сервиса</th>
              <td>{{ table.items.service_level }}%</td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>

      <div style="overflow: hidden;" class="apex-hidden-scrollbar">
        <apexchart
          v-show="view === 'graph1'"
          type="pie"
          :options="chartOptions"
          :series="series"
        />
      </div>
      
    </div>

    <v-progress-linear
      v-else
      indeterminate
      color="success"
    ></v-progress-linear>
  </div>
</template>


<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'AcceptedMissed',
  props: {
    view: String,
    widget: Object,
  },
  data() {
    return {
      isLoaded: false,

      table: {
        items: {},
        headersTranslate: {
          accepted_calls_count: 'Принятые',
          missed_calls_count_less_wait_time: 'Пропущенные с ожиданием менее порогового значения',
          missed_calls_count_more_wait_time: 'Пропущенные с ожиданием более порогового значения',
          missed_calls_count_exitwithkey: 'Выход из очереди по нажатию',
          missed_calls_count_exitwithtimeout: 'Выход из очереди по таймауту',
          service_level: 'Фактический уровень сервиса',
        },
      },

      chartOptions: {
        chart: {
          type: 'pie',
          background: '#00000000'
        },
        legend: {
          show: false,
          // position: 'bottom'
        },
        colors: [
          '#4CAF50',
          '#FF9800',
          '#F44336',
        ],
        labels: [
          'Принятые',
          'Пропущенные с ожиданием менее порогового значения',
          'Пропущенные с ожиданием более порогового значения',
        ],
        theme: {
          mode: 'dark'
        },
        tooltip: {
          theme: 'dark',
          custom: this.tooltip,
        },
      },
      series: [],

      labelesForTooltip: [
        'Принятые',
        'Пропущенные с ожиданием <br> менее порогового значения',
        'Пропущенные с ожиданием <br> более порогового значения',
        'Выход из очереди по нажатию',
        'Выход из очереди по таймауту',
      ],
      colorsForTooltip: [
        '#4CAF50',
        '#FF9800',
        '#F44336',
      ],
    }
  },

  computed: {
    ...mapGetters({
    }),

    isDarkTheme() {
      return this.$vuetify.theme.isDark;
    },
  },

  watch: {
    isDarkTheme() {
      this.changeApexTheme();
    },

    view() {
      window.dispatchEvent(new Event('resize')) //Очередной костылик для отрисовки "бублика"
    },

  },

  methods: {
    ...mapActions({
      loadAcceptedMissedWidget: 'dashboard/loadAcceptedMissedWidget',
    }),

    tooltip({series, seriesIndex: index}) {
      let label = this.labelesForTooltip[index]
      let color = this.colorsForTooltip[index]
      let val = series[index]
      return `<div class="apexcharts-tooltip-rangebar" style="background: ${color};color: white;">
          <span>
            ${label}: ${val}
          </span>
        </div>
      `
    },

    changeApexTheme() {
      if (this.isDarkTheme) {
        this.chartOptions = {
          chart: {
            background: '#00000000'
          },
          theme: {
            mode: 'dark',
          },
        };
      } else {
        this.chartOptions = {
          chart: {
            background: '#00000000'
          },
          theme: {
            mode: 'light',
          },
        };
      }
    },

    async loadData() {
      this.isLoaded = false;
      let items = await this.loadAcceptedMissedWidget(this.widget.params);
      this.table.items = items;
      this.fillItemsForApex(items);
      this.isLoaded = true;
    },

    fillItemsForApex(items) {
      let options = JSON.parse(JSON.stringify(this.chartOptions));
      // Это извращение чтоб чарты нормально свои опции подхватывали =(((
      setTimeout(() => {
        this.series = [];
        this.series.push(+items.accepted_calls_count);
        this.series.push(+items.missed_calls_count_less_wait_time);
        this.series.push(+items.missed_calls_count_more_wait_time);
        this.series.push(+items.missed_calls_count_exitwithkey);
        this.series.push(+items.missed_calls_count_exitwithtimeout);
        this.chartOptions = Object.assign(this.chartOptions, options);
      }, 500);
    },
  },
  
  async mounted() {
    await this.loadData();
    this.changeApexTheme();
  },
}
</script>


<style scoped lang="scss">

</style>